<template>
  <button
      class="flex justify-center shadow-md transform hover:-translate-y-1 duration-200 rounded-md cursor-pointer items-center w-48 pr-2 text-sm"
      @click="addToCart">
          <shopping-bag-logo-white />
          <h2>
              {{title ? title : $t('product.addToCart')}}
          </h2>
  </button>
</template>

<script>
import ShoppingBagLogoWhite from '@/components/graphics/ShoppingBagLogoWhite.vue';
import { addProductToCart } from '@/services/ProductService';

export default {
  props: {
    product: Object,
    quantity: Number,
    title: String,
  },

  components: {
    ShoppingBagLogoWhite,
  },

  methods: {
    addToCart() {
      if (!this.product) {
        this.createNotification('info', 'Funzione non ancora disponibile');
        return;
      }
      addProductToCart(this.product, this.quantity);
      this.createNotification('success', this.$t('product.addedToCart'));
    },
  },
};
</script>
